import { Fragment, h } from "preact";
import { useState } from "preact/hooks";
import { useSelector } from "react-redux";

import i18n from "../i18n.js";
import { selectCanSeeTalentPool } from "../store/talentPoolSlice.js";
import {
  downloadFile,
  stringTofileName,
  talentStateIsChoosable,
} from "../helpers.js";
import { selectCurrentUserIsAdmin } from "../store/currentUserSlice.js";
import usePreviewClickHandler from "../hooks/usePreviewClickHandler.js";
import useTalentFavoriteAction from "../hooks/useTalentFavoriteAction.jsx";

import Dropdown from "./Dropdown.jsx";
import IconButton from "./IconButton.jsx";
import ShareProfileDialog from "./ShareProfileDialog.jsx";
import DefineStateDialog from "./DefineStateDialog.jsx";
import { createPortal } from "preact/compat";
import AddToProjectModal from "./AddToProjectModal.jsx";

export default function TalentMoreAction({ setTalent, talent }) {
  const isAdmin = useSelector(selectCurrentUserIsAdmin);
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [openedDefineStateDialog, setOpenedDefineStateDialog] = useState(false);
  const [openedProjectModal, setOpenedProjectModal] = useState(false);
  const { handleClickWhenLoggedIn } = usePreviewClickHandler(
    selectCanSeeTalentPool
  );

  function handleShareClick() {
    setShareDialogOpen(true);
  }

  function handleStateChange(newData) {
    setTalent && setTalent({ ...talent, state: newData.state });
  }
  function handleFavChange(newData) {
    setTalent && setTalent({ ...talent, favorite: newData.favorite });
  }

  const moreActionOptions = [
    {
      trackingName: "Add to project",
      icon: "folder",
      onClick: handleClickWhenLoggedIn(() => setOpenedProjectModal(true)),
      text: i18n.t("component.add_to_project_button.label"),
      props: {
        class: "show-on-small",
      },
    },
    useTalentFavoriteAction({
      talent,
      onChange: handleFavChange,
      onClick: handleClickWhenLoggedIn(null),
      visualOnly: true,
    }),
    talentStateIsChoosable(talent)
      ? {
          trackingName: "Define state",
          icon: "define_state",
          text: i18n.t("pages.projects.talent_table.actions.define_state"),
          onClick: handleClickWhenLoggedIn(() =>
            setOpenedDefineStateDialog(true)
          ),
        }
      : null,
    {
      trackingName: "Download resume",
      icon: "download_new",
      text: i18n.t("component.talent_action.action.download_resume"),
      onClick: handleClickWhenLoggedIn(function () {
        downloadFile(
          talent.data.resume.url,
          `resume_${stringTofileName(talent.data.name)}`
        );
      }),
    },
    {
      trackingName: "Share profile",
      icon: "share_new",
      onClick: handleClickWhenLoggedIn(handleShareClick),
      text: i18n.t("pages.projects.talent_table.actions.share"),
    },
  ];

  return (
    <>
      <Dropdown
        triggerClass="inline-flex-center"
        items={moreActionOptions}
        absolute={true}
        container={document.getElementById("modals")}
        trackingName="Talent:Open more"
      >
        <IconButton text>more</IconButton>
      </Dropdown>
      {shareDialogOpen && (
        <ShareProfileDialog
          onClose={() => setShareDialogOpen(false)}
          talent={talent}
        />
      )}
      {openedDefineStateDialog && (
        <DefineStateDialog
          talent={talent}
          onChange={handleStateChange}
          onClose={() => setOpenedDefineStateDialog(false)}
        />
      )}
      {openedProjectModal &&
        createPortal(
          <div class="nioomi-modal-wrapper">
            <AddToProjectModal
              talent={talent}
              admin={isAdmin}
              close={() => setOpenedProjectModal(false)}
              opened={openedProjectModal}
            />
          </div>,
          document.getElementById("modals")
        )}
    </>
  );
}
